import dayjs from 'dayjs';
import { assign } from '@atds-legacy/lang';
import { Record } from '@redge-media/fo-js-sdk';
import { ProductType } from '@/shared/enums';
import bookmark, { defaultBookmark } from '@/shared/libs/helpers/bookmark';
import cover from '@/shared/libs/helpers/cover';
import { services } from '@/shared/plugins/services';

const Program = Record.mixin(cover).extend({
  constructor: function Program(attrs = {}, opts = {}) {
    Record.call(this, assign(attrs, {
      recording: {},
      bookmark: attrs.bookmark || assign({}, defaultBookmark),
    }), opts);

    this.liveManager = services.resolve('liveManager');
    this._progress = 0;
    this._timestamp = new Date().valueOf();
    this._isCurrent = false;
    assign(this, bookmark(this));

    this.normalize();
  },

  get isPlaybackDisabled() {
    const channel = this.liveManager.channels.get(this.channelId);

    return channel && !channel.allowProgrammePlaybackOnAvod && !this.allowPlayback;
  },

  get isCurrent() {
    return this._isCurrent;
  },

  set isCurrent(value) {
    this._isCurrent = value;
  },

  get progress() {
    return this._progress;
  },

  set progress(value) {
    this._progress = value;
  },

  get duration() {
    if (!this.sinceDate || !this.tillDate) {
      return 0;
    }

    return this.tillDate.diff(this.sinceDate, 's');
  },

  parseUrl(url) {
    const phrase = `timestamp=${this._timestamp}`;
    return url.indexOf('?') !== -1
      ? `${url}&${phrase}`
      : `${url}?${phrase}`;
  },

  set(key, value, opts = {}) {
    const data = Record.prototype.set.call(this, key, value, opts);
    this.normalize();
    return data;
  },

  normalize() {
    this.sinceDate = dayjs(this.since);
    this.tillDate = dayjs(this.till);
    this.since = dayjs(this.since).valueOf();
    this.till = dayjs(this.till).valueOf();

    if (!this.type) {
      this.type = ProductType.PROGRAMME;
    }

    if (!this.slug) {
      this.slug = '_';
    }

    if (this.live) {
      this.channelId = this.live.id;
      delete this.live;
    }

    return this;
  },
});

export default Program;
